import React from "react"

import useSubscriptionLimits from "@/hooks/useSubscriptionLimits"

import BoardList from "@/pages/Admin/Boards/BoardList"
import UpsellBoardPage from "@/pages/Admin/Boards/UpsellBoardPage"
import { Loading } from "letalkui"

const Boards = () => {
	const funnelSubscriptionData = useSubscriptionLimits("permission", "funnel")

	const canViewBoardList = !funnelSubscriptionData.mustBlock

	return <Loading.FallbackSpinner isLoading={funnelSubscriptionData.isLoading}>
		{!canViewBoardList ? <UpsellBoardPage /> : <BoardList />}
	</Loading.FallbackSpinner>
}

export default Boards
